import { Link } from "react-router-dom";
import React from "react";
import { formattedPrice } from "../utils";

function formatUrlString(inputString) {
  // Pretvara sva velika slova u mala
  const lowercaseString = inputString.toLowerCase();

  // Zamjenjuje sve razmake i specijalne karaktere sa -
  const formattedString = lowercaseString
    .replace(/[^\w\s]/gi, "")
    .replace(/\s+/g, "-");

  return formattedString;
}

const CheckoutProductItem = ({ item }) => {
  console.log(item, "item");
  return (
    <div className="checkout-information-list-item">
      <div className="checkout-information-list-item-image">
        <Link to={`/proizvod/${formatUrlString(item.name)}/${item.id}`}>
          <div className="checkout-information-list-item-qty">
            {item?.quantity}
          </div>
          <img src={item?.images?.[0]} alt="UP-IT" />
        </Link>
      </div>
      <div className="checkout-information-list-item-text">
        <Link to={`/proizvod/${formatUrlString(item.name)}/${item.id}`}>
          <h5>
            {item?.name} x {item?.quantity}
          </h5>
          <div className="checkout-information-list-item-price-grinding">
            <div className="checkout-information-list-item-price">
              {item?.quantity} x{" "}
              {formattedPrice(item?.fixPrice || item?.cashPrice)}{" "}
              <small>RSD</small>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default CheckoutProductItem;
